import './App.scss';
import './styles/_paddings.scss';
import Homepage from './pages/home/Homepage';
function App() {

  return (
    <div className='App'>
      <Homepage />
    </div>
  );
}

export default App;
